/* ============================================
   DETT-PRODOTTO.JS — Nymphai Product Detail
   Page-specific animations (GSAP + ScrollTrigger)
   ============================================
   DEPENDENCY: shared.js must be loaded BEFORE this file.
   shared.js provides: GSAP plugin registration,
   Preloader, Lenis (window.lenis), Burger Menu,
   Custom Cursor, Nav Scroll Detection.
   ============================================ */


/* ---------- INTER-SECTION PARALLAX ---------- */
(function () {
  var sections = gsap.utils.toArray(
    '.dett-info, .dett-texture, .dett-perche, .dett-prefooter'
  );
  if (!sections.length) return;

  sections.forEach(function (section) {
    // Inner content rises slightly faster than scroll — subtle depth
    var inner = section.querySelector(
      '.dett-info__inner, .dett-texture__inner, .dett-perche__inner, .dett-prefooter__inner'
    );
    if (inner) {
      gsap.fromTo(inner, {
        yPercent: 4,
      }, {
        yPercent: -4,
        ease: 'none',
        scrollTrigger: {
          trigger: section,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
        },
      });
    }
  });
})();


/* ---------- HERO — fade-in + parallax ---------- */
(function () {
  const hero    = document.querySelector('.dett-hero');
  const title   = document.querySelector('.dett-hero__title');
  const sub     = document.querySelector('.dett-hero__subtitle');
  const bottom  = document.querySelector('.dett-hero__bottom');
  if (!hero) return;

  function runIntro() {
    if (title)  gsap.set(title, { y: 40 });
    if (sub)    gsap.set(sub,   { y: 30 });
    var tl = gsap.timeline({ defaults: { ease: 'power3.out' } });
    if (title)  tl.to(title,  { opacity: 1, y: 0, duration: 1.2 }, 0.2);
    if (sub)    tl.to(sub,    { opacity: 1, y: 0, duration: 1 },   0.5);
    if (bottom) tl.from(bottom, { yPercent: 100, opacity: 0, duration: 0.8 }, 0);
  }

  window.addEventListener('preloader-done', runIntro, { once: true });

  // Scroll dissolve — video blurs, content fades, overlay darkens
  var heroVideo = hero.querySelector('.dett-hero__video');
  var heroContent = hero.querySelector('.dett-hero__content');

  var dissolveTl = gsap.timeline({
    scrollTrigger: {
      trigger: hero,
      start: 'top top',
      end: 'bottom top',
      scrub: true,
    },
  });

  // Video blur
  if (heroVideo) {
    dissolveTl.fromTo(heroVideo,
      { filter: 'blur(0px)' },
      { filter: 'blur(14px)', ease: 'none' }, 0
    );
  }

  // Overlay darkens
  dissolveTl.to('.dett-hero__overlay', { opacity: 0.5, ease: 'none' }, 0);

  // Content drifts up and fades
  if (heroContent) {
    dissolveTl.to(heroContent, { yPercent: -25, opacity: 0, ease: 'none' }, 0);
  }


  // Info section rises gently over the hero
  var infoSection = document.querySelector('.dett-info');
  if (infoSection) {
    gsap.fromTo(infoSection, {
      yPercent: 3,
    }, {
      yPercent: 0,
      ease: 'none',
      scrollTrigger: {
        trigger: hero,
        start: '60% top',
        end: 'bottom top',
        scrub: true,
      },
    });
  }
})();


/* ---------- INFO / BENEFICI — reveal ---------- */
(function () {
  const section = document.querySelector('.dett-info');
  if (!section) return;

  // Title
  const title = section.querySelector('.dett-info__title');
  if (title) {
    gsap.from(title, {
      y: 60,
      opacity: 0,
      duration: 1,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: title,
        start: 'top 85%',
      },
    });
  }

  // Images — stagger reveal
  const images = section.querySelectorAll('.dett-info__img');
  if (images.length) {
    gsap.from(images, {
      y: 80,
      opacity: 0,
      duration: 1,
      stagger: 0.25,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: images[0],
        start: 'top 85%',
      },
    });
  }

  // donna-crema — gentle parallax
  var donnaCrema = section.querySelector('.dett-info__img--2');
  if (donnaCrema) {
    gsap.fromTo(donnaCrema, { yPercent: 8 }, {
      yPercent: -5,
      ease: 'none',
      scrollTrigger: {
        trigger: donnaCrema,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
      },
    });
  }

  // Benefits list — stagger
  const items = section.querySelectorAll('.dett-info__benefits li');
  if (items.length) {
    gsap.from(items, {
      x: 40,
      opacity: 0,
      duration: 0.8,
      stagger: 0.15,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: '.dett-info__benefits',
        start: 'top 85%',
      },
    });
  }

  // Copy heading
  const copyHeading = section.querySelector('.dett-info__copy-heading');
  if (copyHeading) {
    gsap.from(copyHeading, {
      y: 50,
      opacity: 0,
      duration: 1,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: copyHeading,
        start: 'top 85%',
      },
    });
  }

  // Copy columns — slide up
  const cols = section.querySelectorAll('.dett-info__copy-col');
  if (cols.length) {
    gsap.from(cols, {
      y: 50,
      opacity: 0,
      duration: 0.9,
      stagger: 0.2,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: cols[0],
        start: 'top 85%',
      },
    });
  }

  // Copy columns — vertical line grows
  var copyLine = section.querySelector('.dett-info__copy-columns');
  if (copyLine) {
    gsap.to(copyLine, { '--line-h': '100%', duration: 1, ease: 'power2.out',
      scrollTrigger: { trigger: copyLine, start: 'top 85%' },
    });
  }

  // Dafne image — SVG mask reveal with displacement filter
  var maskDafne = section.querySelector('#circleMask-dafne circle');
  var imgDafne  = section.querySelector('#circleMask-dafne')
                  ? section.querySelector('.dett-info__img-dafne image') : null;
  if (maskDafne && imgDafne) {
    var finalRDafne = parseFloat(maskDafne.getAttribute('data-value-final'));
    if (window.innerWidth <= 1024) {
      maskDafne.setAttribute('r', finalRDafne);
    } else {
      gsap.timeline({
        scrollTrigger: {
          trigger: '.dett-info__img-dafne',
          start: 'top 85%',
          end: '+=40%',
          scrub: true,
        },
      })
      .fromTo(maskDafne, { attr: { r: 0 } }, { attr: { r: finalRDafne }, ease: 'none' }, 0)
      .fromTo(imgDafne, { scale: 1.1, transformOrigin: '50% 50%' }, { scale: 1, ease: 'none' }, 0);
    }
  }

  // Dafne — gentle parallax on the container
  var dafneWrap = section.querySelector('.dett-info__img-dafne');
  if (dafneWrap) {
    gsap.fromTo(dafneWrap, { yPercent: 6 }, {
      yPercent: -4,
      ease: 'none',
      scrollTrigger: {
        trigger: dafneWrap,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
      },
    });
  }
})();


/* ---------- BENEFITS ACCORDION ---------- */
(function () {
  var benefits = document.querySelectorAll('.dett-info__benefit');
  if (!benefits.length) return;

  benefits.forEach(function (benefit) {
    var trigger = benefit.querySelector('.dett-info__benefit-trigger');
    var body = benefit.querySelector('.dett-info__benefit-body');
    if (!trigger || !body) return;

    trigger.addEventListener('click', function () {
      var isOpen = benefit.classList.contains('is-open');

      if (isOpen) {
        // Close this one
        gsap.to(body, {
          height: 0,
          opacity: 0,
          duration: 0.4,
          ease: 'power2.inOut',
          onComplete: function () {
            benefit.classList.remove('is-open');
            trigger.setAttribute('aria-expanded', 'false');
          }
        });
      } else {
        // Close all others first
        benefits.forEach(function (other) {
          if (other !== benefit && other.classList.contains('is-open')) {
            var otherBody = other.querySelector('.dett-info__benefit-body');
            var otherTrigger = other.querySelector('.dett-info__benefit-trigger');
            gsap.to(otherBody, {
              height: 0,
              opacity: 0,
              duration: 0.3,
              ease: 'power2.inOut'
            });
            other.classList.remove('is-open');
            otherTrigger.setAttribute('aria-expanded', 'false');
          }
        });

        // Open this one
        benefit.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        gsap.fromTo(body, {
          height: 0,
          opacity: 0
        }, {
          height: 'auto',
          opacity: 1,
          duration: 0.5,
          ease: 'power2.out'
        });
      }
    });
  });
})();


/* ---------- HORIZONTAL SCROLL — Ingredienti ---------- */
(function () {
  const wrap  = document.querySelector('.dett-hscroll-wrap');
  const track = document.querySelector('.dett-hscroll__track');
  if (!wrap || !track) return;

  function initHScroll() {
    // Kill previous instances on resize
    ScrollTrigger.getAll().forEach(function (t) {
      if (t.vars.id === 'dett-hscroll' || t.vars.id === 'dett-hscroll-text') t.kill();
    });

    var totalWidth = track.scrollWidth;
    var viewWidth  = window.innerWidth;
    var distance   = totalWidth - viewWidth;
    if (distance <= 0) {
      // Mobile/tablet: SVG mask reveal driven by vertical scroll
      var mobileMasks = [
        { mask: '#circleMask-ragazze circle', trigger: '.dett-hscroll__bridge-img', img: '.dett-hscroll__bridge-img image' },
        { mask: '#circleMask-crema circle', trigger: '.dett-hscroll__crema-img', img: '.dett-hscroll__crema-img image' }
      ];
      mobileMasks.forEach(function (item) {
        var maskEl = track.querySelector(item.mask);
        var imgEl = track.querySelector(item.img);
        if (maskEl) {
          var finalR = parseFloat(maskEl.getAttribute('data-value-final'));
          if (window.innerWidth <= 1024) { maskEl.setAttribute('r', finalR); return; }
          gsap.fromTo(maskEl,
            { attr: { r: 0 } },
            { attr: { r: finalR }, ease: 'none',
              scrollTrigger: {
                id: 'dett-hscroll-text',
                trigger: item.trigger,
                start: 'top 80%',
                end: 'top 30%',
                scrub: true,
              },
            }
          );
          if (imgEl) {
            gsap.fromTo(imgEl,
              { scale: 1.08, transformOrigin: '50% 50%' },
              { scale: 1, ease: 'none',
                scrollTrigger: {
                  id: 'dett-hscroll-text',
                  trigger: item.trigger,
                  start: 'top 80%',
                  end: 'top 30%',
                  scrub: true,
                },
              }
            );
          }
        }
      });
      // Bridge video mobile: clip-path circle reveal
      var mobileBridgeVideo = track.querySelector('#bridge-video');
      if (mobileBridgeVideo) {
        gsap.fromTo(mobileBridgeVideo,
          { clipPath: 'inset(50% round 12px)' },
          { clipPath: 'inset(0% round 12px)', ease: 'none',
            scrollTrigger: {
              trigger: '.dett-hscroll__bridge-img',
              start: 'top 80%',
              end: 'top 30%',
              scrub: true,
              onLeave: function () {
                gsap.set(mobileBridgeVideo, { clipPath: 'inset(0% round 12px)' });
              },
            },
          }
        );
        ScrollTrigger.create({
          trigger: '.dett-hscroll__bridge-img',
          start: 'top 80%',
          end: 'bottom top',
          onEnter:     function () { mobileBridgeVideo.play().catch(function(){}); },
          onLeave:     function () { mobileBridgeVideo.pause(); },
          onEnterBack: function () { mobileBridgeVideo.play().catch(function(){}); },
          onLeaveBack: function () { mobileBridgeVideo.pause(); },
        });
      }
      return;
    }

    // Main horizontal tween
    var scrollTween = gsap.to(track, {
      x: -distance,
      ease: 'none',
      scrollTrigger: {
        id: 'dett-hscroll',
        trigger: wrap,
        pin: true,
        scrub: 1,
        end: function () { return '+=' + distance; },
        invalidateOnRefresh: true,
      },
    });

    // --- Text & image reveals inside horizontal scroll ---

    // Heading "Ingredienti chiave"
    var heading = track.querySelector('.dett-hscroll__heading');
    if (heading) {
      gsap.from(heading, {
        y: 60, opacity: 0, ease: 'power3.out', duration: 0.8,
        scrollTrigger: {
          id: 'dett-hscroll-text',
          trigger: heading,
          containerAnimation: scrollTween,
          start: 'left 90%',
          toggleActions: 'play none none reverse',
        },
      });
    }

    // Panel 1: label + paragraph
    var textBlock1 = track.querySelector('.dett-hscroll__text-block--1');
    if (textBlock1) {
      var label1 = textBlock1.querySelector('.dett-hscroll__label');
      var para1  = textBlock1.querySelector('p');
      if (label1) {
        gsap.from(label1, {
          y: 40, opacity: 0, ease: 'power2.out',
          scrollTrigger: {
            id: 'dett-hscroll-text',
            trigger: label1,
            containerAnimation: scrollTween,
            start: 'left 75%',
            toggleActions: 'play none none reverse',
          },
        });
      }
      if (para1) {
        gsap.from(para1, {
          y: 40, opacity: 0, ease: 'power2.out',
          scrollTrigger: {
            id: 'dett-hscroll-text',
            trigger: para1,
            containerAnimation: scrollTween,
            start: 'left 75%',
            toggleActions: 'play none none reverse',
          },
        });
      }
      // Vertical line grows
      gsap.to(textBlock1, { '--line-h': '100%', ease: 'power2.out',
        scrollTrigger: {
          id: 'dett-hscroll-text',
          trigger: textBlock1,
          containerAnimation: scrollTween,
          start: 'left 75%',
          toggleActions: 'play none none reverse',
        },
      });
    }

    // Panel 1: second text block (label + paragraph)
    var textBlock2 = track.querySelector('.dett-hscroll__text-block--2');
    if (textBlock2) {
      var label1b = textBlock2.querySelector('.dett-hscroll__label');
      var para1b  = textBlock2.querySelector('p');
      if (label1b) {
        gsap.from(label1b, {
          y: 40, opacity: 0, ease: 'power2.out',
          scrollTrigger: {
            id: 'dett-hscroll-text2',
            trigger: label1b,
            containerAnimation: scrollTween,
            start: 'left 75%',
            toggleActions: 'play none none reverse',
          },
        });
      }
      if (para1b) {
        gsap.from(para1b, {
          y: 40, opacity: 0, ease: 'power2.out',
          scrollTrigger: {
            id: 'dett-hscroll-text2',
            trigger: para1b,
            containerAnimation: scrollTween,
            start: 'left 75%',
            toggleActions: 'play none none reverse',
          },
        });
      }
      // Vertical line grows
      gsap.to(textBlock2, { '--line-h': '100%', ease: 'power2.out',
        scrollTrigger: {
          id: 'dett-hscroll-text2',
          trigger: textBlock2,
          containerAnimation: scrollTween,
          start: 'left 75%',
          toggleActions: 'play none none reverse',
        },
      });
    }

    // Panel 2: center block (label + paragraph)
    var centerBlock = track.querySelector('.dett-hscroll__center-block');
    if (centerBlock) {
      var label2 = centerBlock.querySelector('.dett-hscroll__label');
      var para2  = centerBlock.querySelector('p');
      if (label2) {
        gsap.from(label2, {
          y: 50, opacity: 0, ease: 'power2.out',
          scrollTrigger: {
            id: 'dett-hscroll-text',
            trigger: label2,
            containerAnimation: scrollTween,
            start: 'left 80%',
            toggleActions: 'play none none reverse',
          },
        });
      }
      if (para2) {
        gsap.from(para2, {
          y: 40, opacity: 0, ease: 'power2.out',
          scrollTrigger: {
            id: 'dett-hscroll-text',
            trigger: para2,
            containerAnimation: scrollTween,
            start: 'left 75%',
            toggleActions: 'play none none reverse',
          },
        });
      }
    }

    // Bridge image (ragazze) — SVG mask reveal
    var maskRagazze = track.querySelector('#circleMask-ragazze circle');
    var imgRagazze  = maskRagazze
      ? track.querySelector('.dett-hscroll__bridge-img image')
      : null;
    if (maskRagazze) {
      var finalRRagazze = parseFloat(maskRagazze.getAttribute('data-value-final'));
      if (window.innerWidth <= 1024) {
        maskRagazze.setAttribute('r', finalRRagazze);
      } else {
        gsap.fromTo(maskRagazze,
          { attr: { r: 0 } },
          { attr: { r: finalRRagazze }, ease: 'none',
            scrollTrigger: {
              id: 'dett-hscroll-text',
              trigger: '.dett-hscroll__bridge-img',
              containerAnimation: scrollTween,
              start: 'left 85%',
              end: 'left 40%',
              scrub: true,
            },
          }
        );
      }
      if (imgRagazze) {
        gsap.fromTo(imgRagazze,
          { scale: 1.08, transformOrigin: '50% 50%' },
          { scale: 1, ease: 'none',
            scrollTrigger: {
              id: 'dett-hscroll-text',
              trigger: '.dett-hscroll__bridge-img',
              containerAnimation: scrollTween,
              start: 'left 85%',
              end: 'left 40%',
              scrub: true,
            },
          }
        );
      }
    }
    // Bridge video — CSS clip-path circle reveal + play/pause
    var bridgeVideo = track.querySelector('#bridge-video');
    if (bridgeVideo) {
      gsap.fromTo(bridgeVideo,
        { clipPath: 'inset(50% round 12px)' },
        { clipPath: 'inset(0% round 12px)', ease: 'none',
          scrollTrigger: {
            trigger: '.dett-hscroll__bridge-img',
            containerAnimation: scrollTween,
            start: 'left 85%',
            end: 'left 40%',
            scrub: true,
            onLeave: function () {
              gsap.set(bridgeVideo, { clipPath: 'inset(0% round 12px)' });
            },
          },
        }
      );
      ScrollTrigger.create({
        trigger: '.dett-hscroll__bridge-img',
        containerAnimation: scrollTween,
        start: 'left 85%',
        end: 'right 15%',
        onEnter:     function () { bridgeVideo.play().catch(function(){}); },
        onLeave:     function () { bridgeVideo.pause(); },
        onEnterBack: function () { bridgeVideo.play().catch(function(){}); },
        onLeaveBack: function () { bridgeVideo.pause(); },
      });
    }

    // Crema image — SVG mask reveal
    var maskCrema = track.querySelector('#circleMask-crema circle');
    var imgCrema  = maskCrema ? track.querySelector('.dett-hscroll__crema-img image') : null;
    if (maskCrema && imgCrema) {
      var finalRCrema = parseFloat(maskCrema.getAttribute('data-value-final'));
      if (window.innerWidth <= 1024) {
        maskCrema.setAttribute('r', finalRCrema);
      } else {
        gsap.fromTo(maskCrema,
          { attr: { r: 0 } },
          { attr: { r: finalRCrema }, ease: 'none',
            scrollTrigger: {
              id: 'dett-hscroll-text',
              trigger: '.dett-hscroll__crema-img',
              containerAnimation: scrollTween,
              start: 'left 80%',
              end: 'left 35%',
              scrub: true,
            },
          }
        );
      }
      gsap.fromTo(imgCrema,
        { scale: 1.1, transformOrigin: '50% 50%' },
        { scale: 1, ease: 'none',
          scrollTrigger: {
            id: 'dett-hscroll-text',
            trigger: '.dett-hscroll__crema-img',
            containerAnimation: scrollTween,
            start: 'left 80%',
            end: 'left 35%',
            scrub: true,
          },
        }
      );
    }
  }

  initHScroll();

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initHScroll, 250);
  });

  // Keyboard navigation: arrow keys scroll the pinned h-scroll section
  var hscrollEl = document.getElementById('dett-hscroll');
  if (hscrollEl) {
    hscrollEl.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault();
        window.lenis.scrollTo(window.scrollY + window.innerWidth * 0.3, { duration: 0.6 });
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault();
        window.lenis.scrollTo(window.scrollY - window.innerWidth * 0.3, { duration: 0.6 });
      }
    });
  }
})();


/* ---------- TEXTURE — video + text reveal ---------- */
(function () {
  const section = document.querySelector('.dett-texture');
  if (!section) return;

  // Video play/pause
  const video = document.getElementById('texture-video');
  if (video) {
    ScrollTrigger.create({
      trigger: '#dett-texture',
      start: 'top 80%',
      end: 'bottom 20%',
      onEnter:     function () { video.play(); },
      onLeave:     function () { video.pause(); },
      onEnterBack: function () { video.play(); },
      onLeaveBack: function () { video.pause(); },
    });
  }

  // Mobile video play/pause (≤430px — bypassa SVG foreignObject iOS bug)
  var mobileVideo = document.querySelector('.dett-texture__video-mobile video');
  if (mobileVideo) {
    ScrollTrigger.create({
      trigger: '#dett-texture',
      start: 'top 80%',
      end: 'bottom 20%',
      onEnter:     function () { mobileVideo.play(); },
      onLeave:     function () { mobileVideo.pause(); },
      onEnterBack: function () { mobileVideo.play(); },
      onLeaveBack: function () { mobileVideo.pause(); },
    });
  }

  // Video — SVG mask reveal with displacement filter
  var maskVideo = document.querySelector('#circleMask-video circle');
  if (maskVideo) {
    var finalRVideo = parseFloat(maskVideo.getAttribute('data-value-final'));
    if (window.innerWidth <= 1024) {
      maskVideo.setAttribute('r', finalRVideo);
    } else {
      gsap.timeline({
        scrollTrigger: {
          trigger: '.dett-texture__video-wrap',
          start: 'top 85%',
          end: '+=40%',
          scrub: true,
        },
      })
      .fromTo(maskVideo, { attr: { r: 0 } }, { attr: { r: finalRVideo }, ease: 'none' }, 0);
    }
  }

  // Video wrap — gentle parallax
  var videoWrap = section.querySelector('.dett-texture__video-wrap');
  if (videoWrap) {
    gsap.fromTo(videoWrap, { yPercent: 6 }, {
      yPercent: -4,
      ease: 'none',
      scrollTrigger: {
        trigger: videoWrap,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
      },
    });
  }

  // Content — fade in (early) + parallax rise (longer)
  var content = section.querySelector('.dett-texture__content');
  if (content) {
    // Opacity arrives early
    gsap.fromTo(content, { opacity: 0 }, {
      opacity: 1,
      ease: 'none',
      scrollTrigger: {
        trigger: content,
        start: 'top 95%',
        end: 'top 65%',
        scrub: true,
      },
    });

    // Parallax rise continues longer
    gsap.fromTo(content, { yPercent: 8 }, {
      yPercent: -3,
      ease: 'none',
      scrollTrigger: {
        trigger: content,
        start: 'top 95%',
        end: 'top 30%',
        scrub: true,
      },
    });
  }

  // Texture columns — vertical line grows
  var textureLine = section.querySelector('.dett-texture__columns');
  if (textureLine) {
    gsap.to(textureLine, { '--line-h': '100%', duration: 1, ease: 'power2.out',
      scrollTrigger: { trigger: textureLine, start: 'top 80%' },
    });
  }
})();


/* ---------- PERCHÉ — parallax image + text reveal ---------- */
(function () {
  const section = document.querySelector('.dett-perche');
  if (!section) return;

  // Image — SVG mask reveal with displacement filter
  var maskDonne = section.querySelector('#circleMask-donne circle');
  var imgDonne  = maskDonne ? section.querySelector('.dett-perche__image image') : null;
  if (maskDonne && imgDonne) {
    var finalRDonne = parseFloat(maskDonne.getAttribute('data-value-final'));
    if (window.innerWidth <= 1024) {
      maskDonne.setAttribute('r', finalRDonne);
    } else {
      gsap.timeline({
        scrollTrigger: {
          trigger: '.dett-perche__image',
          start: 'top 85%',
          end: '+=40%',
          scrub: true,
        },
      })
      .fromTo(maskDonne, { attr: { r: 0 } }, { attr: { r: finalRDonne }, ease: 'none' }, 0)
      .fromTo(imgDonne, { scale: 1.08, transformOrigin: '50% 50%' }, { scale: 1, ease: 'none' }, 0);
    }
  }

  // Title
  const title = section.querySelector('.dett-perche__title');
  if (title) {
    gsap.from(title, {
      y: 60,
      opacity: 0,
      duration: 1,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: '.dett-perche__bottom',
        start: 'top 85%',
      },
    });
  }

  // Columns
  const cols = section.querySelectorAll('.dett-perche__col');
  if (cols.length) {
    gsap.from(cols, {
      y: 50,
      opacity: 0,
      duration: 0.9,
      stagger: 0.2,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: cols[0],
        start: 'top 85%',
      },
    });
  }

  // Perché columns — vertical line grows
  var percheLine = section.querySelector('.dett-perche__columns');
  if (percheLine) {
    gsap.to(percheLine, { '--line-h': '100%', duration: 1, ease: 'power2.out',
      scrollTrigger: { trigger: percheLine, start: 'top 85%' },
    });
  }
})();


/* ---------- PREFOOTER — Dafne brand rise + image ---------- */
(function () {
  const brand = document.getElementById('dett-prefooter-brand');
  if (!brand) return;

  gsap.fromTo(brand, {
    yPercent: 60,
  }, {
    yPercent: 0,
    ease: 'none',
    scrollTrigger: {
      trigger: '#dett-prefooter',
      start: 'top bottom',
      end: 'bottom bottom',
      scrub: true,
    },
  });

  // Product image — scale up on scroll, no pin
  const img = document.querySelector('.dett-prefooter__image');
  if (img) {
    gsap.fromTo(img,
      { scale: 0.5, opacity: 0.7, borderRadius: '14px' },
      { scale: 1, opacity: 1, borderRadius: '4px',
        duration: 2.5,
        ease: 'slow(0.7, 0.7, false)',
        scrollTrigger: {
          trigger: img,
          scrub: true,
          start: 'top 80%',
          end: 'bottom 40%',
        },
      }
    );
  }
})();


/* ---------- NAV/UI COLOR CHANGE per sezione ---------- */
(function () {
  var nav    = document.querySelector('.dett-nav');
  var burger = document.querySelector('.dett-burger');
  var bottom = document.querySelector('.dett-hero__bottom');
  var cursor = document.getElementById('cursor');
  if (!nav) return;

  function setDark() {
    nav.classList.add('nav--dark');
    if (burger) burger.classList.add('nav--dark');
    if (bottom) bottom.classList.add('bottom--dark');
    if (cursor) cursor.classList.add('Cursor--dark');
  }

  function setLight() {
    nav.classList.remove('nav--dark');
    if (burger) burger.classList.remove('nav--dark');
    if (bottom) bottom.classList.remove('bottom--dark');
    if (cursor) cursor.classList.remove('Cursor--dark');
  }

  // H-Scroll: aspetta che il pin ScrollTrigger sia pronto, poi crea il trigger colore
  // Usiamo un evento refresh per assicurarci che il pin-spacer esista
  ScrollTrigger.addEventListener('refresh', function onRefresh() {
    var hscrollST = ScrollTrigger.getById('dett-hscroll');
    if (!hscrollST) return;
    ScrollTrigger.removeEventListener('refresh', onRefresh);

    ScrollTrigger.create({
      trigger: hscrollST.trigger,
      start: function () { return hscrollST.start; },
      end: function () { return hscrollST.end; },
      onEnter: setDark,
      onLeave: setLight,
      onEnterBack: setDark,
      onLeaveBack: setLight,
    });
  });

  // Cerchio
  var cerchioNav = document.querySelector('.dett-cerchio');
  if (cerchioNav) {
    ScrollTrigger.create({
      trigger: cerchioNav,
      start: 'top 5%',
      end: 'bottom 5%',
      onEnter: setDark,
      onLeave: setLight,
      onEnterBack: setDark,
      onLeaveBack: setLight,
    });
  }
})();



/* ---------- BOTTOM NAV — show/hide + progress bar ---------- */
(function () {
  var bottomNav = document.getElementById('bottom-nav');
  var infoSection = document.querySelector('.dett-info');
  var progressContainer = document.getElementById('bottom-nav-progress');
  if (!bottomNav || !infoSection) return;

  // Generate progress bars (vertical lines)
  var BAR_COUNT = 80;
  var fills = [];
  if (progressContainer) {
    for (var i = 0; i < BAR_COUNT; i++) {
      var bar = document.createElement('div');
      bar.className = 'bottom-nav__progress-bar';
      var fill = document.createElement('div');
      fill.className = 'bottom-nav__progress-bar-fill';
      bar.appendChild(fill);
      progressContainer.appendChild(bar);
      fills.push(fill);
    }

    var progressPct = document.getElementById('bottom-nav-progress-pct');

    // Update progress on scroll (80 external bars + percentage)
    ScrollTrigger.create({
      trigger: 'body',
      start: 'top top',
      end: 'bottom bottom',
      onUpdate: function (self) {
        var progress = self.progress;

        // 80 external bars
        fills.forEach(function (fill, idx) {
          var barProgress = (progress - idx / BAR_COUNT) * BAR_COUNT;
          barProgress = Math.max(0, Math.min(1, barProgress));
          fill.style.height = (barProgress * 100) + '%';
        });

        // Percentage text
        if (progressPct) progressPct.textContent = Math.round(progress * 100) + '%';
      },
    });
  }

  ScrollTrigger.create({
    trigger: infoSection,
    start: 'top 60%',
    end: 'bottom top',
    onEnter: function () {
      gsap.to(bottomNav, {
        y: 0,
        opacity: 1,
        duration: 0.6,
        ease: 'power2.out',
        onStart: function () {
          bottomNav.style.pointerEvents = 'all';
          bottomNav.classList.add('bottom-nav--visible');
        },
      });
    },
    onLeaveBack: function () {
      gsap.to(bottomNav, {
        y: 120,
        opacity: 0,
        duration: 0.4,
        ease: 'power2.in',
        onComplete: function () {
          bottomNav.style.pointerEvents = 'none';
          bottomNav.classList.remove('bottom-nav--visible');
        },
      });
    },
  });

  // Hide bottom nav when footer is visible
  var footerEl = document.querySelector('.footer');
  if (footerEl) {
    ScrollTrigger.create({
      trigger: footerEl,
      start: 'top 90%',
      end: 'bottom bottom',
      onEnter: function () {
        gsap.to(bottomNav, {
          y: 120,
          opacity: 0,
          duration: 0.4,
          ease: 'power2.in',
          onComplete: function () {
            bottomNav.style.pointerEvents = 'none';
          },
        });
      },
      onLeaveBack: function () {
        gsap.to(bottomNav, {
          y: 0,
          opacity: 1,
          duration: 0.6,
          ease: 'power2.out',
          onStart: function () {
            bottomNav.style.pointerEvents = 'all';
          },
        });
      },
    });
  }

  // Quantity selector
  var qtyMinus = document.getElementById('qty-minus');
  var qtyPlus = document.getElementById('qty-plus');
  var qtyValue = document.getElementById('qty-value');
  var priceEl = document.querySelector('.bottom-nav__price');
  // Prezzo in centesimi dal data attribute Liquid (es. 8000 = EUR 80,00)
  var unitPriceCents = priceEl ? parseInt(priceEl.getAttribute('data-unit-price'), 10) || 8000 : 8000;

  if (qtyMinus && qtyPlus && qtyValue) {
    function updatePrice() {
      var qty = parseInt(qtyValue.textContent, 10);
      var totalCents = qty * unitPriceCents;
      var euros = Math.floor(totalCents / 100);
      var cents = String(totalCents % 100).padStart(2, '0');
      if (priceEl) priceEl.textContent = 'EUR ' + euros + ',' + cents;
    }

    qtyMinus.addEventListener('click', function () {
      var qty = parseInt(qtyValue.textContent, 10);
      if (qty > 1) {
        qtyValue.textContent = qty - 1;
        updatePrice();
      }
    });

    qtyPlus.addEventListener('click', function () {
      var qty = parseInt(qtyValue.textContent, 10);
      qtyValue.textContent = qty + 1;
      updatePrice();
    });
  }
})();


/* ---------- CERCHIO — Continuous rotating text ---------- */
(function () {
  var cerchioSvg = document.querySelector('.dett-cerchio__svg');
  if (!cerchioSvg) return;

  gsap.to(cerchioSvg, {
    rotation: 360,
    duration: 20,
    ease: 'none',
    repeat: -1,
    transformOrigin: '50% 50%',
  });
})();


/* ---------- FOOTER — fade in ---------- */
(function () {
  const footer = document.querySelector('.footer');
  if (!footer) return;

  gsap.from(footer, {
    y: 30,
    opacity: 0,
    duration: 0.8,
    ease: 'power2.out',
    scrollTrigger: {
      trigger: footer,
      start: 'top 95%',
    },
  });
})();


/* ---------- FOOTER — cursor dark ---------- */
(function () {
  var footer = document.querySelector('.footer');
  var cursor = document.getElementById('cursor');
  if (!footer || !cursor) return;

  // Usa mouseenter/leave per essere immune ai conflitti
  // con i trigger scroll della sezione cerchio
  footer.addEventListener('mouseenter', function () {
    cursor.classList.add('Cursor--dark');
  });
  footer.addEventListener('mouseleave', function () {
    cursor.classList.remove('Cursor--dark');
  });
})();

/* ---------- FOOTER — is-on-footer nav color ---------- */
(function () {
  var nav    = document.querySelector('.dett-nav');
  var bottom = document.querySelector('.dett-hero__bottom');
  var footer = document.querySelector('.footer');
  if (!nav || !footer) return;

  ScrollTrigger.create({
    trigger: footer,
    start: 'top bottom',
    end: 'bottom top',
    onEnter:     function () { nav.classList.add('is-on-footer');    if (bottom) bottom.classList.add('is-on-footer'); },
    onLeaveBack: function () { nav.classList.remove('is-on-footer'); if (bottom) bottom.classList.remove('is-on-footer'); },
    onLeave:     function () { nav.classList.remove('is-on-footer'); if (bottom) bottom.classList.remove('is-on-footer'); },
  });
})();
